import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import HtmlTooltip from './HtmlTooltip';
import MarkdownRenderer from './MarkdownRenderer';

type HelpTooltipProps = {
  content: string;
};

export default function HelpTooltip({ content }: Readonly<HelpTooltipProps>): React.ReactElement {


  return (
    <HtmlTooltip
      placement="top" arrow
      title={
        <div data-testid="tooltip-content" >
          <MarkdownRenderer markdown={content} invert={false} />
        </div>
      }
    >
      <FuseSvgIcon size={15} className="inline align-top" data-testid="tooltip-icon">
        heroicons-solid:question-mark-circle
      </FuseSvgIcon>
    </HtmlTooltip>
  );
}
